import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/components/legal/legal-page";
import { PRIVACY } from "@/lib/legal";

export const Route = createFileRoute("/privacy")({
  component: () => <LegalPage doc={PRIVACY} />,
});
